module.exports = __webpack_public_path__ + "img/AuctionVintageCar.7d10a7a4.jpg";